module.exports = __webpack_public_path__ + "static/img/lab-m-project.ddd3c0a8.png";